'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.descendants = exports.allDescendants = undefined;

var _ramda = require('ramda');

var _childNodes = require('./childNodes');

var _nodeNames = require('./nodeNames');

var allDescendants = function allDescendants(node) {
	return (0, _ramda.compose)(_ramda.flatten, (0, _ramda.map)((0, _ramda.applySpec)([_ramda.identity, allDescendants])), _childNodes.allChildNodes)(node);
};
// doing this instead of filtering allDescendants in order to avoid building a huge array and filtering it
var descendants = function descendants(localName, uri) {
	return function (node) {
		return (0, _ramda.compose)(_ramda.flatten, (0, _ramda.applySpec)([(0, _ramda.filter)((0, _nodeNames.hasName)(localName, uri)), (0, _ramda.map)(descendants(localName, uri))]), _childNodes.allChildNodes)(node);
	};
};

exports.allDescendants = allDescendants;
exports.descendants = descendants;